/**
 * koruma.tsx
 *
 * NE İŞE YARAR : Yol düzeyinde oturum denetimi — iki yönlü
 * KAYNAK SPEC  : 15-arayuz-standardi.md §7.1 (yetkisi olmayan hiç görmez) · §7.3
 *                (arayüzde gizlemek güvenlik değildir) · §9 (yükleniyor durumu)
 * BAĞLI OLDUĞU : src/oturum/baglam.tsx · react-router-dom · @mantine/core
 * KULLANAN     : src/uygulama.tsx
 * DİKKAT       : 1) BU BİR GÜVENLİK SINIRI DEĞİLDİR (`15` §7.3). Erişimi sunucu
 *                   reddeder; buradaki yönlendirme yalnız kullanıcıyı boşuna bir
 *                   ekranla karşılaştırmamak içindir. Bu dosya bir gün hiç çalışmasa
 *                   da veri sızmaz.
 *                2) OTURUM ÇÖZÜLÜRKEN HİÇBİR YÖNE GİDİLMEZ. Sayfa yenilendiğinde
 *                   belirteç depodan okunup `/me` çözülene kadar kısa bir an geçer; o
 *                   anda yönlendirme yapılsaydı her yenilemede kullanıcı bir anlığına
 *                   giriş ekranını görür ve oturumunun kapandığını sanardı.
 *                3) NEREDEN GELİNDİĞİ TAŞINIR. Giriş sonrası kullanıcı istediği sayfaya
 *                   döner; her seferinde ana ekrana atılsaydı, bir bağlantıyı açan
 *                   kullanıcı giriş yaptıktan sonra o bağlantıyı yeniden bulmak zorunda
 *                   kalırdı.
 *                4) BEKLERKEN ÇARK KULLANILIYOR, İSKELET DEĞİL. `15` §9 iskeleti **liste
 *                   ve detay ekranları** için şart koşuyor — orada korunacak bir sayfa
 *                   yapısı vardır. Burada henüz hangi sayfanın çizileceği bilinmiyor;
 *                   yanlış bir sayfanın iskeletini göstermek, yükleme sırasında var
 *                   olmayan bir ekranı vaat etmek olurdu.
 * SON GÜNCELLEME: 2026-08-31 04:35:00
 */
import { Center, Loader } from '@mantine/core';
import type { ReactElement, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useOturum } from './baglam';

/** Giriş sonrası dönülecek yol — `KimlikYolu` bunu okur (başlıktaki not 3). */
export interface HedefDurumu {
  readonly hedef?: string;
}

function Bekleme(): ReactElement {
  return (
    <Center mih="100vh">
      <Loader />
    </Center>
  );
}

/** Oturum isteyen yollar. */
export function KorumaliYol({ children }: { children: ReactNode }): ReactElement {
  const { durum } = useOturum();
  const konum = useLocation();

  if (durum === 'COZULUYOR') {
    return <Bekleme />; // Başlıktaki not 2.
  }

  if (durum === 'KAPALI') {
    const durumBilgisi: HedefDurumu = { hedef: konum.pathname };
    return <Navigate to="/giris" replace state={durumBilgisi} />;
  }

  return <>{children}</>;
}

/**
 * Kimlik yolları — oturumu **açık** kullanıcıyı içeri geri gönderir.
 *
 * İkinci bir giriş ikinci bir `app_session` açar ve cihaz sınırı boşuna dolardı
 * (`uygulama.tsx` notu 2).
 */
export function KimlikYolu({ children }: { children: ReactNode }): ReactElement {
  const { durum } = useOturum();

  if (durum === 'COZULUYOR') {
    return <Bekleme />;
  }

  if (durum === 'ACIK') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
